// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Minoxidil / Finasteride /Tret  (Men & Women) 09.17.26" (bfe282ed-e0e7-45df-a520-1611e1b1b098). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiMinoxidilFinasterideTretMenWomenQuestions = [
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryDueEitherBeing',
    label:
      "We're sorry, due to either being pregnant, trying to conceive, or current breastfeeding, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '597a12e7-1434-497e-b08b-7e8c4974ce03',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear',
    label:
      'Are you currently trying to conceive or plan on conceiving in the near future?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'a1c8af8f-36e6-4374-bad6-7a4f544f03a9' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryBasedPreviousResponse',
    label:
      "We're sorry, based on your previous response, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'c9662a03-2f85-4e3c-88f5-030b557f996d',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_requiredAcknowledgmentUnderstandFormulationContains',
    label:
      'Required Acknowledgment: I understand this formulation contains both Finasteride and Tretinoin, which may pose risks during pregnancy and must not be used if pregnant or attempting conception.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'i_agree', value: 'I agree' }]
    },
    extras: { mdiQuestionId: '102b5a62-d1de-4387-ad98-7747f386fd4f' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_primaryConcern',
    label: 'What is your primary concern?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hair_thinning', value: 'Hair thinning' },
        { key: 'receding_hairline', value: 'Receding hairline' },
        { key: 'bald_spots', value: 'Bald spots' },
        { key: 'excess_shedding', value: 'Excess shedding' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '6068355f-5447-4f9f-8379-37042d2b3ddf' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_didFirstNoticeHairLoss',
    label: 'When did you first notice hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_6_months_ago', value: 'Less than 6 months ago' },
        { key: 'o_6_12_months_ago', value: '6-12 months ago' },
        { key: 'o_1_3_years_ago', value: '1-3 years ago' },
        { key: 'longer_than_3_years_ago', value: 'Longer than 3 years ago' }
      ]
    },
    extras: { mdiQuestionId: 'ddb3b831-edce-4dbb-a644-03055f95ffc7' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_whereHairLossOccurring',
    label: 'Where is the hair loss occurring?',
    type: 'select',
    educationalSlide: '(Select all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'crown', value: 'Crown' },
        { key: 'temples', value: 'Temples' },
        { key: 'entire_scalp', value: 'Entire scalp' },
        { key: 'patchy_areas', value: 'Patchy areas' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '9f75c82d-46ce-4334-97ca-ec8bd40ae88c' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_hairLoss',
    label: 'Has your hair loss:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'stayed_the_same', value: 'Stayed the same' },
        { key: 'gradually_worsened', value: 'Gradually worsened' },
        { key: 'rapidly_worsened', value: 'Rapidly worsened' }
      ]
    },
    extras: { mdiQuestionId: '162b7be6-49cb-4ffb-9bf6-107fc39a0573' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_familyHistoryHairLoss',
    label: 'Do you have a family history of hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' },
        { key: 'unsure', value: 'Unsure' }
      ]
    },
    extras: { mdiQuestionId: '71833cae-f659-4517-bf2e-f832d56f2371' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_conditions',
    label: 'Do you have any of the following conditions?',
    type: 'select',
    educationalSlide: '(Select all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'liver_disease', value: 'Liver disease' },
        {
          key: 'hormonal_disorders_e_g_pcos_thyroid_issu',
          value: 'Hormonal disorders (e.g., PCOS, thyroid issues)'
        },
        {
          key: 'scalp_conditions_eczema_psoriasis_infect',
          value: 'Scalp conditions (eczema, psoriasis, infections)'
        },
        {
          key: 'anemia_or_nutrient_deficiency',
          value: 'Anemia or nutrient deficiency'
        },
        {
          key: 'skin_conditions_eczema_psoriasis_dermati',
          value: 'Skin conditions (eczema, psoriasis, dermatitis)'
        },
        { key: 'prostate_conditions', value: 'Prostate conditions' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'a5f6d850-bcc2-409b-8b3d-ce3b54c7e800' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_everDiagnosed',
    label: 'Have you ever been diagnosed with any of the following?',
    type: 'select',
    educationalSlide: '(select any that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'androgenetic_alopecia', value: 'Androgenetic alopecia' },
        { key: 'alopecia_areata', value: 'Alopecia areata' },
        { key: 'telogen_effluvium', value: 'Telogen effluvium' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '16b964b9-7a7c-4c04-aa0c-57adcab72432' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRegarding',
    label:
      'Can you provide your doctor with more insight regarding your diagnosis?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRegarding',
      rows: 4
    },
    extras: { mdiQuestionId: '9a33191f-492b-4320-b327-598206f39942' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_usingHairLossTreatmentsIncludes',
    label:
      'Are you currently using any hair loss treatments? This includes any oral or topical products.',
    type: 'select',
    educationalSlide:
      'If yes, please list what treatments you are currently using.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'ac9d04be-5cf8-4963-98f8-32b3da2f6ff1' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_youuseProducts',
    label: 'Have youuse any of the following products?',
    type: 'select',
    educationalSlide:
      'Select those that apply, then further explain your experience.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'minoxidil',
          value: 'Minoxidil',
          answer: {
            type: 'text',
            name: 'minoxidil_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'retinoids_e_g_tretinoin',
          value: 'Retinoids (e.g., tretinoin)',
          answer: {
            type: 'text',
            name: 'retinoids_e_g_tretinoin_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'alcohol_based_topicals',
          value: 'Alcohol-based topicals',
          answer: {
            type: 'text',
            name: 'alcohol_based_topicals_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'finasteride',
          value: 'Finasteride',
          answer: {
            type: 'text',
            name: 'finasteride_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'dutasteride',
          value: 'Dutasteride',
          answer: {
            type: 'text',
            name: 'dutasteride_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'ketoconazole_shampoo',
          value: 'Ketoconazole shampoo',
          answer: {
            type: 'text',
            name: 'ketoconazole_shampoo_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'microneedling',
          value: 'Microneedling',
          answer: {
            type: 'text',
            name: 'microneedling_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'prp',
          value: 'PRP',
          answer: {
            type: 'text',
            name: 'prp_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'i_have_not_tried_any_of_the_above_produc',
          value: 'I have NOT tried any of the above products'
        }
      ]
    },
    extras: { mdiQuestionId: '87236d53-e4e0-42c1-bcf8-dbf1b577d537' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried',
    label: 'How was your experience with the products you tried?',
    type: 'info',
    subLabel: 'Did you have any side effects?  Did you notice improvement?',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried',
      rows: 4
    },
    extras: { mdiQuestionId: 'c96360a8-7d75-450c-bab5-66889d0eb738' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_scalpIrritationOpenWoundsInfection',
    label: 'Do you have scalp irritation, open wounds, or infection?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '80fe9e9d-6b60-4917-b145-97cd2bfc9809' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_redness',
    label: 'Do you currently have:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'redness', value: 'Redness' },
        { key: 'flaking', value: 'Flaking' },
        { key: 'itching', value: 'Itching' },
        { key: 'burning', value: 'Burning' },
        { key: 'none', value: 'None' }
      ]
    },
    extras: { mdiQuestionId: 'efa6ba44-6be6-4e7a-a059-74a058053b41' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_history',
    label: 'Do you have a history of',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'eczema', value: 'Eczema' },
        { key: 'seborrheic_dermatitis', value: 'Seborrheic dermatitis' },
        { key: 'psoriasis', value: 'Psoriasis' },
        { key: 'contact_dermatitis', value: 'Contact dermatitis' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'cb03cf11-5b1d-489d-866c-56b51efa515a' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_usingScalp',
    label: 'Are you currently using any of the following on your scalp?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'exfoliating_acids_salicylic_glycolic_lac',
          value: 'Exfoliating acids (salicylic, glycolic, lactic)'
        },
        { key: 'medicated_shampoos', value: 'Medicated shampoos' },
        { key: 'topical_steroids', value: 'Topical steroids' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '3eee3779-f7f1-4e00-87d5-1de8be0d0104' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_historyLowBloodPressureDizziness',
    label: 'Do you have a history of low blood pressure or dizziness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '72fd0145-c049-4320-808a-21202432dace' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_experiencedDecreasedLibidoLately',
    label: 'Have you experienced decreased libido lately?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '5d3824f0-2a61-436b-8f9e-e83a9dcb3455' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_experienced',
    label: 'Have you experienced any of the following?',
    type: 'select',
    educationalSlide: '(select those that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'decreased_libido', value: 'Decreased libido' },
        { key: 'erectile_dysfunction', value: 'Erectile dysfunction' },
        { key: 'ejaculatory_issues', value: 'Ejaculatory issues' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'c0af3cea-a045-4ad5-8c3c-2a3ba19c6a0e' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_historyDepressionAnxietyMoodDisorders',
    label: 'Do you have a history of depression, anxiety, or mood disorders?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '2010e824-3c2a-4b6d-91fa-14a00ee49d96' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_provideDoctorFurtherInsightHistory',
    label:
      'Can you please provide your doctor with further insight to your history ofdepression, anxiety, or mood disorders?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorFurtherInsightHistory',
      rows: 4
    },
    extras: { mdiQuestionId: '1767c812-7068-4a54-9716-74a6c240a9d9' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_history2',
    label: 'Do you have a history of any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        { key: 'severe_depression', value: 'Severe depression' },
        {
          key: 'neither_of_these_apply_to_me',
          value: 'Neither of these apply to me'
        }
      ]
    },
    extras: { mdiQuestionId: 'd1ea511a-026d-4763-aff6-483d37b029fc' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_ever',
    label: 'Have you ever had any of the following:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'elevated_psa_levels', value: 'Elevated PSA levels' },
        { key: 'prostate_issues', value: 'Prostate issues' },
        { key: 'prostate_cancer', value: 'Prostate cancer' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'b6826e35-1687-4e48-80b2-7c2f9567e05f' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_rateStressLevelDailyBasis',
    label: 'How would you rate your stress level on a daily basis?',
    type: 'info',
    subLabel: '0: No stress 10: I am constantly experiencing stress',
    answer: {
      type: 'number',
      name: 'mdiMinoxidilFinasterideTretMenWomen_rateStressLevelDailyBasis'
    },
    extras: { mdiQuestionId: '3716c57c-894a-4861-99b7-a795b21cbcc7' }
  },
  {
    field:
      'mdiMinoxidilFinasterideTretMenWomen_experiencedRecentMajorStressIllness',
    label:
      'Have you experienced a recent major stress, illness, or weight loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'b98533a0-c07a-4e53-98b9-e6602444bb43' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRecent',
    label:
      'Can you provide your doctor with more insight to your recent major stress, illness, or weight loss:',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRecent',
      rows: 4
    },
    extras: { mdiQuestionId: 'b523b671-25da-49a7-b4a9-f295df15089a' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_uploadClearWellLitPhoto',
    label: 'Please upload a clear, well-lit photo of the affected area:',
    type: 'file_upload',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId:
          'mdiMinoxidilFinasterideTretMenWomen_uploadClearWellLitPhoto',
        buttonLabel: 'Upload'
      }
    ],
    extras: { mdiQuestionId: '7e664765-e51f-4811-a2f6-7c8f39347fea' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideTretMenWomen_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: '8e063f71-e7f9-4180-94e8-d0cef36dd4dc' }
  },
  {
    field: 'mdiMinoxidilFinasterideTretMenWomen_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiMinoxidilFinasterideTretMenWomenAnswerField = Partial<
  QuestionAnswerMap<typeof mdiMinoxidilFinasterideTretMenWomenQuestions>
>;

export default mdiMinoxidilFinasterideTretMenWomenQuestions;
